import { useState, useEffect } from "react";

// hooks
import { useApolloMutation } from "frontend/utils/apolloApi/useApolloMutation.js";
import { useBatchApproval } from "../useBatchApproval";

// GQL
import { VISUALLY_PUBLISH_PHOTO_UPLOADS } from "frontend/components/fort/mod/photos/gql/mutations";

export const useVisuallyApprove = () => {
    // Hooks/State
    const { apolloMutate, loading } = useApolloMutation({
        actionDesc: "Visually Approve Upload(s)",
        gql: VISUALLY_PUBLISH_PHOTO_UPLOADS
    });
    const [isEditable, setIsEditable] = useState(true);

    // Props
    const title = "Visually Approve";

    const useBatchApprovalConfig = {
        title,
        onApprovalAction: async ({ photoUploadIds }) => {
            return await apolloMutate({ variables: { photoUploadIds } });
        }
    };

    const {
        selectedUploadIds,
        allFlagsCleared,
        publishingIsEditable,
        decoratedOnApproval
    } = useBatchApproval(useBatchApprovalConfig);

    // side effects
    useEffect(() => {
        let isEditable =
            !loading && selectedUploadIds.length > 0 && publishingIsEditable;

        if (!allFlagsCleared) {
            isEditable = false;
        }

        setIsEditable(isEditable);
    }, [selectedUploadIds, publishingIsEditable, allFlagsCleared, loading]);

    return {
        onVisuallyPublish: decoratedOnApproval,
        isEditable
    };
};
